import React, { useRef, useEffect, useState } from "react";

export default function VideoGlobe(props) {
  const mesh = useRef();
  const [hovered, setHovered] = useState(false);

  useEffect(() => {
    document.body.style.cursor = hovered ? "pointer" : "auto";
  }, [hovered]);

  return (
    <group>
      <mesh
        ref={mesh}
        scale={props.scale}
        position={props.position}
        onClick={props.buttonPress}
        onPointerOver={(event) => {
          console.log(event);
          setHovered(true);
        }}
        onPointerOut={(event) => {
          console.log(event);
          setHovered(false);
        }}
      >
        {/* <sphereGeometry args={[0.7, 100, 100]} />
                <meshNormalMaterial /> */}

        <circleGeometry args={[0.7, 100]} />
        <meshStandardMaterial
          attach="material"
          map={props.texture1}
          transparent
          roughness={0.8}
          metalness={0.8}
          opacity={1}
        />
      </mesh>
      {/* <mesh position={props.position}>
                <ringBufferGeometry attach="geometry" args={[0.8, 0.82, 128]} />
            </mesh> */}
    </group>
  );
}
